import { Suspense, lazy } from 'react'
import { Routes, Route } from 'react-router-dom'
import MainLayout from './layouts/MainLayout'

// Lazy load pages
const HomePage = lazy(() => import('./pages/HomePage'))
const AboutPage = lazy(() => import('./pages/AboutPage'))
const StrategyPage = lazy(() => import('./pages/StrategyPage'))
const TrackRecordPage = lazy(() => import('./pages/TrackRecordPage'))
const InvestPage = lazy(() => import('./pages/InvestPage'))
const ContactPage = lazy(() => import('./pages/ContactPage'))

// Resources
const ResourcesPage = lazy(() => import('./pages/resources/ResourcesPage'))
const UnderwritingBasicsPage = lazy(() => import('./pages/resources/UnderwritingBasicsPage'))
const FinancingOptionsPage = lazy(() => import('./pages/resources/FinancingOptionsPage'))
const DealCriteriaPage = lazy(() => import('./pages/resources/DealCriteriaPage'))
const DueDiligenceChecklistPage = lazy(() => import('./pages/resources/DueDiligenceChecklistPage'))
const PropertyComparisonSheetPage = lazy(() => import('./pages/resources/PropertyComparisonSheetPage'))
const RentalCalculatorPage = lazy(() => import('./pages/resources/RentalCalculatorPage'))
const ClevelandOverviewPage = lazy(() => import('./pages/resources/ClevelandOverviewPage'))

// Calculators
const CalculatorsPage = lazy(() => import('./pages/calculators/CalculatorsPage'))
const MortgagePaymentCalculator = lazy(() => import('./pages/calculators/MortgagePaymentCalculator'))
const CashOnCashCalculator = lazy(() => import('./pages/calculators/CashOnCashCalculator'))
const DscrCalculator = lazy(() => import('./pages/calculators/DscrCalculator'))
const RentVsBuyCalculator = lazy(() => import('./pages/calculators/RentVsBuyCalculator'))
const BrrrrCalculator = lazy(() => import('./pages/calculators/BrrrrCalculator'))

const NotFoundPage = lazy(() => import('./pages/NotFoundPage'))

function LoadingFallback() {
  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <div className="animate-pulse text-muted-foreground">Loading...</div>
    </div>
  )
}

export default function App() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route element={<MainLayout />}>
          {/* Main pages */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/strategy" element={<StrategyPage />} />
          <Route path="/track-record" element={<TrackRecordPage />} />
          <Route path="/invest" element={<InvestPage />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* Resources */}
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/resources/underwriting-basics" element={<UnderwritingBasicsPage />} />
          <Route path="/resources/financing-options" element={<FinancingOptionsPage />} />
          <Route path="/resources/deal-criteria" element={<DealCriteriaPage />} />
          <Route path="/resources/due-diligence-checklist" element={<DueDiligenceChecklistPage />} />
          <Route path="/resources/property-comparison-sheet" element={<PropertyComparisonSheetPage />} />
          <Route path="/resources/rental-calculator" element={<RentalCalculatorPage />} />
          <Route path="/resources/cleveland-overview" element={<ClevelandOverviewPage />} />

          {/* Calculators */}
          <Route path="/resources/calculators" element={<CalculatorsPage />} />
          <Route path="/resources/calculators/mortgage-payment" element={<MortgagePaymentCalculator />} />
          <Route path="/resources/calculators/cash-on-cash" element={<CashOnCashCalculator />} />
          <Route path="/resources/calculators/dscr" element={<DscrCalculator />} />
          <Route path="/resources/calculators/rent-vs-buy" element={<RentVsBuyCalculator />} />
          <Route path="/resources/calculators/brrrr" element={<BrrrrCalculator />} />

          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  )
}
